import { useEffect, useState } from 'react';
import { scopes as tableScopes } from '../../../constants/scopes';
import { getCompanyById } from '../../../api/companyApi';
import { getGameById } from '../../../api/gameApi';
import { getKeyProviderById } from '../../../api/keyProviderApi';
import { getPlatformById } from '../../../api/platformApi';
import { getSkuById } from '../../../api/skuApi';
import { getUserById } from '../../../api/userApi';
import { getWorkflowById } from '../../../api/workflowApi';

export function useInheritedScopeNameResolution(
  effectiveScopes: Record<string, string>,
  drillScopes: Record<string, string>
) {
  const [resolvedInheritedNames, setResolvedInheritedNames] = useState<
    Record<string, string>
  >({});

  useEffect(() => {
    const inheritedScopeKeys = Object.keys(effectiveScopes ?? {}).filter(
      (scopeKey) => !drillScopes?.[scopeKey]
    );

    inheritedScopeKeys.forEach((scopeKey) => {
      const scopeId = effectiveScopes?.[scopeKey];
      if (!scopeId) return;

      const cacheKey = `${scopeKey}:${scopeId}`;
      if (resolvedInheritedNames[cacheKey]) return;

      if (scopeKey === tableScopes.GAME) {
        getGameById(scopeId)
          .then((game: any) => {
            const name = game?.name ?? game?.gameName ?? game?.title;
            if (!name) return;
            setResolvedInheritedNames((prev) => ({ ...prev, [cacheKey]: name }));
          })
          .catch(() => {});
      }

      if (scopeKey === tableScopes.KEYPROVIDER) {
        getKeyProviderById(scopeId)
          .then((kp: any) => {
            const name = kp?.name ?? kp?.keyProviderName;
            if (!name) return;
            setResolvedInheritedNames((prev) => ({ ...prev, [cacheKey]: name }));
          })
          .catch(() => {});
      }

      if (scopeKey === tableScopes.USER) {
        getUserById(scopeId)
          .then((user: any) => {
            const name = user?.fullName ?? user?.username ?? user?.name;
            if (!name) return;
            setResolvedInheritedNames((prev) => ({ ...prev, [cacheKey]: name }));
          })
          .catch(() => {});
      }

      if (scopeKey === tableScopes.SKU) {
        getSkuById(scopeId)
          .then((sku: any) => {
            const name = sku?.name ?? sku?.skuName;
            if (!name) return;
            setResolvedInheritedNames((prev) => ({ ...prev, [cacheKey]: name }));
          })
          .catch(() => {});
      }

      if (scopeKey === tableScopes.COMPANY) {
        getCompanyById(scopeId)
          .then((company: any) => {
            const name = company?.companyName ?? company?.name;
            if (!name) return;
            setResolvedInheritedNames((prev) => ({ ...prev, [cacheKey]: name }));
          })
          .catch(() => {});
      }

      if (scopeKey === tableScopes.PLATFORM) {
        getPlatformById(scopeId)
          .then((platform: any) => {
            const name = platform?.name ?? platform?.platformName;
            if (!name) return;
            setResolvedInheritedNames((prev) => ({ ...prev, [cacheKey]: name }));
          })
          .catch(() => {});
      }

      if (scopeKey === tableScopes.KEYWORKFLOW) {
        getWorkflowById(scopeId)
          .then((workflow: any) => {
            const name = workflow?.name ?? workflow?.workflowName;
            if (!name) return;
            setResolvedInheritedNames((prev) => ({ ...prev, [cacheKey]: name }));
          })
          .catch(() => {});
      }
    });
  }, [drillScopes, effectiveScopes, resolvedInheritedNames]);

  return resolvedInheritedNames;
}
